<div
  class="w-100 header"
  [ngClass]="{ home: isHome, exteraContent: exteraContent }"
>
  @if (backIcon) {
    <div class="back-icon">
      <ngx-button
        [mode]="'icon-only'"
        [style]="'neutral-link'"
        [size]="'medium'"
        [leftIcon]="{ name: 'arrow-right' }"
        (clickHandler)="onBackClicked()"
      >
      </ngx-button>
    </div>
  }
  <div class="title">
    <span>
      {{ pageTitle | translate: { option: pageTitleOptions } }}
    </span>
  </div>

  @if (exteraContent) {
    <ng-content></ng-content>
  }
</div>
